import { render } from "./QuizMultiSingleField.vue?vue&type=template&id=78a471c5"
import script from "./QuizMultiSingleField.vue?vue&type=script&lang=js"
export * from "./QuizMultiSingleField.vue?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__